// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Da3jBk1212Y1clUFgI_o {
  position: fixed;
  left: 0;
  top: 0;
  z-index: var(--dry-tooltip-zindex);
  background-color: var(--dry-tooltip-bg);
  color: var(--dry-tooltip-color);
  border-radius: var(--dry-border-radius);
  padding: 2px 5px;
  white-space: nowrap;
  pointer-events: none;
}
.Da3jBk1212Y1clUFgI_o {
  animation: appear 0.6s linear 1;
}
.Da3jBk1212Y1clUFgI_o > code {
  margin-left: 1em;
  text-align: center;
  font-size: 0.9em;
  opacity: 0.6;
  color: var(--dry-tooltip-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `Da3jBk1212Y1clUFgI_o`
};
export default ___CSS_LOADER_EXPORT___;
